import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';

function initSwiperSlider() {
    if ($('.swiperSlider').length) {
        return new Swiper('.swiperSlider', {
            modules: [Navigation],
            lazy: true,
            lazyPreloadPrevNext: 1,
            slidesPerView: 2.5,
            slidesPerGroup: 2,
            spaceBetween: 3,
            speed: 700,
            breakpoints: {
                1024: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                addIcons: false,
            },
        });
    }

    return null;
}

$(function () {
    initSwiperSlider();
});
